module.exports = "/img/notification-icon@2x.png?0e03ddedc53b92da5829ffe8ec76c6b4";